import { FeatureFlags } from "./FeatureFlags";

export const getFeatureFlags = (): FeatureFlags => {
    return {
        IsReact: {
            LeftNav: {
                Mobilytics: false,
                MobilyticsPlaces: true,
            },
            RightNav: {
                MobilyticsBenchmark: true,
            },
            Toolbox: {
                MapSettings: false,
            },
        },
        Interop: {
            InfiniteLoopDetection: true,
            InfiniteLoopDetectionLogging: true,
            DieOnInfiniteLoopDetection: true,
        },
        WorkplaceForMobilyticsVisitorsOnMap: true,
        AllowOverrideTradeAreaMapDelay: true,
        DigitalShare: {
            Footer: true,
            PrintMultiBrand: true,
        },
        NewUI:{
            VoidGap: false,
        },
        Debug: {
            ActionLogging: false,
            BlockedUIDetection: false,
            UseReduxDevTools: false,
        },
        Mobilytics: {
            newRelativeVolume: false,
        },
        Benchmarking: {
            ThematicTile: true
        },
        Factor: {
            scoutToFactorPolygons: true
        }
    };
};
